import BaseCrudService from '@/services/base-crud-service'
import userInviteConfig from '@/config/user-invite-config'
import axiosHttp from '@/utilities/axios-http'

class UserInvitesService extends BaseCrudService {
  validateToken = token => {
    return axiosHttp.get(`${this.resourcePath}/${token}/validate`)
  }

  confirmInvite = payload => {
    return axiosHttp.post(`${this.resourcePath}/${payload.id}/confirm`, {
      invite_token: payload.token,
      password: payload.password
    })
  }
}

export default new UserInvitesService(userInviteConfig.API_RESOURCE)
